var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents4" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("div", { staticClass: "text1" }, [_vm._v("서울 오피스 오시는길")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "map" },
        [
          _c(
            "gmap-map",
            {
              attrs: { id: "map", center: _vm.map.center, zoom: _vm.map.zoom }
            },
            [
              _c("gmap-marker", {
                attrs: {
                  position: _vm.markers.position,
                  icon: _vm.markers.icon
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text2" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "wrap" }, [
          _c("div", { staticClass: "title" }, [_vm._v("가산점 사옥")]),
          _vm._v(" "),
          _c("div", { staticClass: "body" }, [
            _vm._v("\n            서울시 금천구 디지털로 9길 68"),
            _c("br"),
            _vm._v("\n            대륭포스트타워 5차 1106호\n          ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "wrap" }, [
          _c("p", [
            _c("span", [_vm._v("TEL.")]),
            _vm._v(" 1600.0222"),
            _c("br"),
            _vm._v(" "),
            _c("span", [_vm._v("FAX.")]),
            _vm._v(" 02.2624.3360\n          ")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-450522f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450522f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/intro/Contents3.vue
// module id = null
// module chunks = 